import React, { useState } from "react"
import { useHistory } from "react-router"
import { ISearchEsProduct, searchEsProduct } from '../../../api'
import { ProductModel } from "../../../models"
import { useAsync } from "../../../utils"
import Search, { useSearch } from "../../shared/Search"

const SearchMedigoProduct = React.memo(() => {
    const history = useHistory()

    const search = useSearch()

    const searchProductAsync = useAsync(searchEsProduct)

    const [state, setState] = useState<{
        from: number,
        size: number,
        listProduct: Array<ProductModel>,
        outOfData: boolean,
        total?: number,
    }>({
        from: 0,
        size: 10,
        listProduct: [],
        outOfData: false,
        total: 0,
    })

    const getQuery = ({ search, from, size }: ISearchEsProduct) => {
        return {
            from,
            size,
            _source: ["name", "imageUrls", "pageUrl", '_id'],
            query: {
                bool: {
                    must: [
                        {
                            match: {
                                name: {
                                    query: search,
                                    prefix_length: 2,
                                    fuzziness: "AUTO"
                                }
                            }
                        }
                    ],
                    should: [
                        { // Boost score
                            match: {
                                "name.shingles": {
                                    query: search
                                }
                            }
                        },
                        {
                            match_phrase: {
                                Ten_tren_hop: {
                                    query: search,
                                    slop: 3
                                }
                            }
                        }
                    ]
                }
            }
        }
    }

    const resetState = () => {
        setState({
            from: 0,
            size: 10,
            listProduct: [],
            outOfData: false,
            total: 0
        })
    }

    const handleSeach = (value: string) => {
        if (value === '') {
            resetState()
            return
        }

        const params = {
            from: state.from,
            size: state.size,
            search: value,
        }
        searchProductAsync.execute(getQuery(params)).then(res => {
            setState(prev => ({
                ...prev,
                from: 0,
                listProduct: res.data,
                total: res.total,
                outOfData: res.data.length === 0
            }))
        })
    }

    const onScrollHitBottom = () => {
        if (state.outOfData) return
        const params = {
            from: state.from + 10,
            size: state.size,
            search: search.getValue(),
        }

        searchProductAsync.execute(getQuery(params)).then(res => {
            setState(prev => ({
                ...prev,
                from: prev.from + 10,
                listProduct: [...prev.listProduct, ...res.data],
                total: res.total,
                outOfData: res.data.length < 10
            }))
        })
    }

    return <div className='w-100'>
        <div id="main">
            <div className="container" >
                <Search
                    register={search}
                    placeholder='Tên sản phẩm'
                    onClear={resetState}
                    debounceTime={300}
                    onSearch={handleSeach}
                    onScrollHitBottom={onScrollHitBottom}
                    data={state.listProduct}
                    loading={searchProductAsync.status === "loading"}
                    dropdownData={(listProduct: Array<ProductModel>, onSelect: () => void) => {
                        return listProduct.map((product: ProductModel, index) => {
                            return <li onClick={() => {
                                history.push(`/product-detail-dashboard?tab=detail&productId=${product._id}`)
                                onSelect()
                            }
                            }>
                                <a href="/#" onClick={(e) => { e.preventDefault(); }}>
                                    <strong>{product.name}</strong><br />
                                    <small className="txt-gray"></small>
                                </a>
                            </li>
                        })
                    }}
                />
            </div>
        </div>
    </div>
})

export default SearchMedigoProduct